import React, { useEffect, useState } from "react";
import { useError } from "../../context/errorContext";
import axiosInstance from "../../api/axiosInstance";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import moment from "moment/moment";
import "./bills.scss"

const Bills = () => {
    const [bills, setBills] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const { showMessage } = useError();

    useEffect(() => {
        const fetchAllRef = async () => {
            try {
                const [billsRes] = await Promise.all([
                    axiosInstance.get(`ergo/bills`)
                ]);

                setBills(billsRes.data || []);
                setLoading(false);
            } catch (err) {
                console.log(err)
            }
        }
        fetchAllRef()
    }, [])

    const openDocument = async (fileName) => {
        try {
            const res = await axiosInstance.get(`files/deliverynote/${fileName}`, {
                responseType: 'blob',
            });
            const fileURL = URL.createObjectURL(res.data);
            window.open(fileURL, "_blank");
        } catch (err) {
            const blob = err.response?.data;

            if (blob instanceof Blob) {
                const { error } = JSON.parse(await blob.text());
                showMessage(error);
            } else {
                showMessage(err.message);
            }
        }
    };

    if (isLoading) return <div className="loading" />

    const hasData = bills && bills.length > 0;
    if (!hasData)
        return (
            <div className="bills">
                <div className="container">
                    <div className="header">
                        <h1>Rechnungen</h1>
                    </div>
                    <div className="noData">
                        <span>Keine Rechnungen gefunden.</span>
                    </div>
                </div>
            </div>
        );

    return (
        <div className="bills">
            <div className="container">
                <div className="header">
                    <h1>Rechnungen</h1>
                </div>
                <div className="content">
                    <div className="tableWrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Nr.</th>
                                    <th>Datum</th>
                                    <th>Zahlungsbedingung</th>
                                    <th>Fälligkeitsdatum</th>
                                    <th>Rechnungsbetrag</th>
                                    <th className="options"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {bills.map((item, index) => (
                                    <tr key={index}
                                        onClick={() =>
                                            openDocument(`HF${item.SERIALNR}-${item.BILLID}-${item.BILLYEAR}.pdf`)
                                        }
                                    >
                                        <td>{item.SERIALNR}/{item.BILLID}</td>
                                        <td>{moment(item.BILLDATE).format("DD.MM.YYYY")}</td>
                                        <td>{item.PAYMENTDESCRIPTION}</td>
                                        <td>{moment(item.BILLDATE).add(item.RATE, 'days').format("DD.MM.YYYY")}</td>
                                        <td>{item.STDTOTALAMOUNT.toLocaleString('de-DE')} €</td>
                                        <td className="options">
                                            <div className="controls">
                                                <DescriptionOutlinedIcon />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div >
    )
};

export default Bills